// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__37xXl","bigColWidth":"Table_bigColWidth__2e4Eb","biggerColWidth":"Table_biggerColWidth__tRvJS","row":"Table_row__3PdSk","col":"Table_col__1OSYd"};